import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Link, useParams } from "react-router-dom"
import { bindActionCreators } from "redux"
import { callRegionPost, callRegionPut, callRegionViewGet, callRegionClearView } from "../../actions/regions"

let RegionEdit = ({ setPageAttr, methods: { callRegionPost, callRegionViewGet, callRegionPut, callRegionClearView }, view }) => {
    const params = useParams()
    const [id] = useState(!params.id ? '' : params.id)
    const [name, setName] = useState('')

    useEffect(() => {
        callRegionClearView()
        let tabs
        if (!id) {
            tabs = [
                {
                    active: false,
                    to: '/regions',
                    label: 'Informações'
                },
                {
                    active: true,
                    to: '/regions/add',
                    label: 'Adicionar'
                }
            ]
        } else {
            callRegionViewGet(id)
            tabs = [
                {
                    active: false,
                    to: '/regions',
                    label: 'Informações'
                },
                {
                    active: true,
                    to: '/regions/edit/' + id,
                    label: 'Editar'
                }
            ]
        }

        setPageAttr({
            title: 'Região - ' + (!id ? 'Novo' : 'Editar'),
            caption: 'Preencha os campos para inserir as informações',
            btns: [],
            tabs: tabs
        })
    }, [setPageAttr, id, callRegionViewGet, callRegionClearView])

    useEffect(() => {
        setName(view.name)
    }, [view, setName])

    const finishedSubmit = () => {
        setName('')
        window.navigate('/regions')
    }

    const submit = (e) => {
        e.preventDefault()

        let data = {
            name: name
        }

        if (!id) {
            callRegionPost(data, () => finishedSubmit())
        } else {
            callRegionPut(id, data, () => finishedSubmit())
        }
    }

    return (
        <form onSubmit={submit}>
            <div className="form-row">
                <div className="col-md-6 form-group">
                    <label className="required">Nome da Categoria:</label>
                    <input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} />
                </div>
            </div>
            <div className="clearfix text-left mt-3">
                <button className="btn btn-primary" type="submit"><i className="mr-1 fas fa-save fa-white"></i>Salvar</button>
                <Link to={'/regions'} className="btn btn-secondary ml-3"><i className="fas fa-arrow-left mr-1"></i>Voltar</Link>
            </div>
        </form>
    )
}

const mapStateToProps = ({ config: { regions: { view } } }) => ({
    view: view,
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callRegionViewGet,
            callRegionPost,
            callRegionClearView,
            callRegionPut
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(RegionEdit)